import { render, staticRenderFns } from "./RosPricingModal.vue?vue&type=template&id=dc4b02b4&scoped=true&"
import script from "./RosPricingModal.vue?vue&type=script&lang=js&"
export * from "./RosPricingModal.vue?vue&type=script&lang=js&"
import style0 from "./RosPricingModal.vue?vue&type=style&index=0&id=dc4b02b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b02b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4b02b4')) {
      api.createRecord('dc4b02b4', component.options)
    } else {
      api.reload('dc4b02b4', component.options)
    }
    module.hot.accept("./RosPricingModal.vue?vue&type=template&id=dc4b02b4&scoped=true&", function () {
      api.rerender('dc4b02b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/RosPricingModal.vue"
export default component.exports